export const baseStyles = {
  sectionTitle: {
    textTransform: "uppercase",
    color: "#8792a0",
    fontSize: "12px",
    fontFamily: "Open Sans, Arial"
  },
  categoryTitle: {
    textTransform: "uppercase",
    color: "#8792a0",
    fontSize: "10px",
    fontFamily: "Open Sans, Arial",
    margin: "0"
  }
};
